import { Realty, services } from '@ambita/ambita-components-core';
import { ApiDistrict } from '../../../typings/CadastreReport';

const { filters } = services;

const transformDistricts = function (districtsData: Realty.ApiResponse, options?: any): any {
  if (districtsData.items && districtsData.items.length > 0) {
    const districts: any = {
      addresses: options && options.address ? [options.address] : []
    };

    districtsData.items.forEach((district: ApiDistrict) => {
      const districtTitle = `${district.ident.districtNumber} ${district.districtName}`;

      if (!districts.municipality && district.municipality) {
        districts.municipalityNumber = filters.padLeft(district.municipality.municipalityNumber, 4, '0');
        districts.municipalityName = district.municipality.municipalityName;
        districts.municipality = `${districts.municipalityNumber} ${districts.municipalityName}`;
      }

      switch (district.ident.districtCode.code) {
        case '1':
        case '2':
          districts.boroughNumber = district.ident.districtNumber;
          districts.boroughName = district.districtName;
          districts.borough = districtTitle;
          break;
        case 'G':
          districts.statisticalUnitNumber = district.ident.districtNumber;
          districts.statisticalUnitName = district.districtName;
          districts.statisticalUnit = districtTitle;
          break;
        case 'V':
          districts.electoralDistrictNumber = district.ident.districtNumber;
          districts.electoralDistrictName = district.districtName;
          districts.electoralDistrict = districtTitle;
          break;
        case 'K':
          districts.parishNumber = district.ident.districtNumber;
          districts.parishName = district.districtName;
          districts.parish = districtTitle;
          break;
        case 'T':
          districts.urbanAreaNumber = district.ident.districtNumber;
          districts.urbanAreaName = district.districtName;
          districts.urbanArea = districtTitle;
          break;
        default:
          break;
      }
    });

    return districts;
  }
};

export default transformDistricts;
